import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=11dd41cb&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=11dd41cb&prod&scoped=true&lang=css"
import style1 from "./Brand.vue?vue&type=style&index=1&id=11dd41cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd41cb",
  null
  
)

export default component.exports